import { ComponentMultiStyleConfig } from "@chakra-ui/react";

import { SystemStyleObject } from "@chakra-ui/theme-tools";

const parts = ["header", "cell", "row"];

const baseStyleCell: SystemStyleObject = {
  whiteSpace: "nowrap"
};

const dataTable: ComponentMultiStyleConfig = {
  parts,
  baseStyle: {
    header: {
      ...baseStyleCell
    },
    cell: {
      ...baseStyleCell
    },
    row: {
      _hover: {
        bg: "misc-hover"
      }
    }
  }
};

export default dataTable;
